import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-53">
      {/* Background Image with Warm Overlay */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1501594907352-04cda38ebc29?q=80&w=2070&auto=format&fit=crop")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-54">
        <div className="absolute inset-0 bg-gradient-to-b from-[#2C2A29]/40 via-[#2C2A29]/30 to-[#FDFBF7] mix-blend-multiply" data-id="element-55" />
        <div className="absolute inset-0 bg-[#C16E53]/10 mix-blend-overlay" data-id="element-56" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-58">
          <span className="block text-white font-medium tracking-widest uppercase text-sm md:text-base mb-4" data-id="element-59">
            Thanks for attending
          </span>
          <h1 className="text-5xl md:text-7xl lg:text-8xl text-white mb-6 drop-shadow-lg" data-id="element-60">
            The Kan Family Reunion
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.5,
        ease: 'easeOut'
      }} className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 text-white/90 text-lg md:text-xl mb-12" data-id="element-61">
          <div className="flex items-center gap-2" data-id="element-62">
            <Calendar className="w-5 h-5 text-amber" data-id="element-63" />
            <span data-id="element-64">June 26–28, 2026</span>
          </div>
          <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-amber" data-id="element-65" />
          <div className="flex items-center gap-2" data-id="element-66">
            <MapPin className="w-5 h-5 text-amber" data-id="element-67" />
            <span data-id="element-68">San Francisco, California</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8,
        ease: 'easeOut'
      }} data-id="element-69">
          <span className="inline-block bg-white/10 text-white border border-white/30 backdrop-blur-sm px-8 py-4 rounded-sm text-lg" data-id="element-70">
            RSVPs Are Now Closed
          </span>
        </motion.div>
      </div>

      {/* Decorative bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#FDFBF7] to-transparent z-10" data-id="element-71" />
    </section>;
}